<div *ngIf="cardInfo() as cardInfo">
  <crm-collapsible-section [maxHeightPx]="100">
    <glxy-form-field bottomSpacing="none">
      <mat-checkbox class="title" [formControl]="completedTaskControl" (change)="updateTaskCompletionStatus()">
        {{ cardInfo.title }}
        <extended>
          <div [innerHtml]="cardInfo.body | sanitizeHtml"></div>
        </extended>
      </mat-checkbox>
    </glxy-form-field>
  </crm-collapsible-section>

  <div class="row">
    <ng-container
      [ngTemplateOutlet]="activityData"
      [ngTemplateOutletContext]="{ label: 'ACTIVITY.TASK.DUE_DATE', value: cardInfo.dueDate | date: dateFormat }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="activityData"
      [ngTemplateOutletContext]="{ label: 'ACTIVITY.TASK.ASSIGNED_TO', value: cardInfo.assignee | translate }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="activityData"
      [ngTemplateOutletContext]="{ label: 'ACTIVITY.TASK.TYPE', value: cardInfo.type }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="activityData"
      [ngTemplateOutletContext]="{ label: 'ACTIVITY.TASK.PRIORITY', value: cardInfo.priority }"
    ></ng-container>
  </div>
</div>

<ng-template #activityData let-label="label" let-value="value">
  <div class="col col-xs-12 col-md-3">
    <div class="activity-data-label">
      {{ label | translate }}
    </div>
    <div class="activity-data-value">
      <!-- ng-container necessary so angular interpolation will add empty -->
      <ng-container *ngIf="value">
        {{ value }}
      </ng-container>
    </div>
  </div>
</ng-template>
